module.exports = __webpack_public_path__ + "static/image5-d649199d77972c414b761ef8e3c2d076.png";